module.exports = __webpack_public_path__ + "img/6-1.caf5530e.png";